/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetBedrockRegionResponseContent
 */
export interface SetBedrockRegionResponseContent {
    /**
     * 
     * @type {string}
     * @memberof SetBedrockRegionResponseContent
     */
    message?: string;
}


/**
 * Check if a given object implements the SetBedrockRegionResponseContent interface.
 */
export function instanceOfSetBedrockRegionResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SetBedrockRegionResponseContentFromJSON(json: any): SetBedrockRegionResponseContent {
    return SetBedrockRegionResponseContentFromJSONTyped(json, false);
}

export function SetBedrockRegionResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetBedrockRegionResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function SetBedrockRegionResponseContentToJSON(value?: SetBedrockRegionResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

